import { Injectable } from '@angular/core';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { DateFormatService } from '../date-format.service';

@Injectable({
  providedIn: 'root',
})
export class CustomNgbDateFormatter extends NgbDateParserFormatter {
  constructor(private dateFormatService: DateFormatService) {
    super();
  }

  parse(value: string): NgbDateStruct {
    return this.dateFormatService.ngbDateFromString(value);
  }

  format(date: NgbDateStruct): string {
    return this.dateFormatService.stringFromNgbDate(date);
  }
}
